import { Feature } from 'common/feature-flag/config';
import { useFeatureEnabledSuspense } from 'common/feature-flag/hooks/useFeatureEnabled';
import { useSelectedWarehouse } from 'common/hooks/useSelectedWarehouse';

function useWarehouseV1Enabled() {
  const { id: warehouseId } = useSelectedWarehouse();

  const enabled = useFeatureEnabledSuspense('warehouse-v1-functionality', [warehouseId]);

  return enabled;
}

export function useInventoryServiceFeatureEnabled() {
  const isV1 = useWarehouseV1Enabled();
  return !isV1;
}

export function useFeatureFlagWithInventoryServiceEnabled(featureFlag: Feature) {
  const { id: warehouseId } = useSelectedWarehouse();

  const inventoryServiceEnabled = useInventoryServiceFeatureEnabled();
  const newFeatureEnabled = useFeatureEnabledSuspense(featureFlag, [warehouseId]);
  return inventoryServiceEnabled && newFeatureEnabled;
}
